/**
 * True while a space switch is in flight. As long as it's set, `app.vue` unmounts
 * layout and page, so no query of the previous space can refetch against the new
 * merchant (Sentry CLICKFIRE-V2-N7 "Publisher not found by user id").
 */
export const useIsMerchantSwitching = () => {
	return useState<boolean>('merchant-switching', () => false);
};
